/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { messageService } from '../../_services/message.service'
import Modal from 'react-responsive-modal'
import messageStatuses from '../../_constants/messageStatuses'
import PicUploaderLiner from '../Shared/PicUploaderLiner'
import DatePicker from '../Shared/DatePicker'
import NumberFormat from 'react-number-format'
import ClassSelect from '../Shared/ClassSelect'
import UnionSelectForAdmin from '../Shared/UnionSelectForAdmin'
import { StatusSelect } from '../Shared/StatusSelect'
import PriceInput from '../Shared/PriceInput'
import moment from 'moment-jalaali' // Notice here !

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { Input } from 'antd'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'

import { config } from '../../config'
const base_url = config.apiBaseUrl
export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
)

function formatDefaultValue(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e.split('T')[0], 'YYYY-MM-DD')
    if (momentValue.isValid()) {
      return momentValue.format('jYYYY/jMM/jDD')
    }
  }
}

const requestData = (pageSize, page, sorted, filtered, dto) => {
  // console.log(dto)
  return new Promise(async (resolve, reject) => {
    // var dto = {};
    dto['pageSize'] = pageSize
    dto['page'] = page + 1
    dto['sorted'] = sorted
    // console.log(JSON.stringify(dto));

    var result = []
    await messageService
      .getAll(JSON.stringify(dto))
      .then(res => {
        // console.log(res)
        result = res
      })
      .catch(() => {
        setTimeout(
          () => requestData(pageSize, page, sorted, filtered, dto),
          2000
        )
      })

    setTimeout(() => resolve(result), 500)
  })
}

class message extends Component {
  constructor(props, context) {
    super(props, context)
    var pageSize = parseInt(localStorage.getItem('pageSize'), 0)

    this.state = {
      initialItems: [],
      data: [],
      modal: false,
      modalHeading: '',
      loading: true,
      confirmDeleteShow: false,
      deleteItemIndex: 0,
      pageSize: pageSize ? pageSize : 10,
      selected: {},
      selectAll: 0,
      dto: {},
      model: {}
    }
  }

  // componentWillMount() {
  //   this.getData()
  // }

  handleModalShow = () => {
    this.setState({ modalHeading: 'جستجو', searchModal: true })
  }

  handleSearchModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ searchModal: false })
  }

  handleModalEdit = e => {
    let _model = this.state.data[e.target.dataset.index]
    // console.log(_model);

    this.setState({
      modal: true,
      model: _model,
      modalHeading:
        'ویرایش پیام "' + _model.firstName + ' ' + _model.lastName + '"'
    })
  }

  handleModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ modal: false })
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false })
  }

  // getData() {

  //   var dto = {
  //     "page": 1,
  //     "pageSize": 5
  //   }
  //   messageService.getAll(JSON.stringify(dto))
  //     .then((res) => {
  //       console.log(res.data)
  //       var data = res.data;
  //       var pageSize = data.result.length > 10 ? 10 : data.result.length;
  //       this.setState({ initialItems: data, pageSize: pageSize, data: data, loading: false, isSubmitting: false, modal: false });
  //     })
  //     .catch((error) => {
  //       this.handleError(error)
  //     });
  // };

  handleError(error) {
    this.setState({ loading: false })
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = e => {
    let _model = this.state.data[e.target.dataset.index]

    this.setState({ confirmDeleteShow: true, model: _model })
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false })

    messageService
      .delete(this.state.model.id)
      .then(res => {
        toastr.success('حذف پیام', 'پیام با موفقیت حذف شد')
        this.table.fireFetchData()
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleSearch = values => {
    this.setState({ loading: true })
    // console.log(values);

    const { dto } = this.state
    if (values) {
      Object.entries(values).reduce((acc, [key, value]) => {
        dto[key] = value ? value : undefined
      })
      this.setState({ dto: dto }, () => {
        this.table.fireFetchData()
      })
    }
  }

  handleSubmit = values => {
    this.setState({ loading: true })

    // values["imagePath"] = undefined;
    values['createDate'] = undefined
    values['currentClass'] = undefined
    values['union'] = undefined
    values['registerDate'] = undefined
    values['licenseDate'] = undefined
    values['licenseNumber'] = undefined
    values['payments'] = undefined
    if (!values.imagePath) {
      values['imagePath'] = undefined
    }

    // console.log(JSON.stringify(values));
    // var formData = convertToFormData(values)
    messageService
      .edit(JSON.stringify(values))
      .then(res => {
        toastr.success(
          'ویرایش پیام',
          'پیام "' +
            values.firstName +
            ' ' +
            values.lastName +
            '" با موفقیت ویرایش شد'
        )
        this.setState({ modal: false })
        this.table.fireFetchData()
      })
      .catch(error => {
        // console.log(error);

        this.handleError(error)
      })
  }

  // componentDidMount(){
  //   this.table.fireFetchData();
  // }

  toggleRow(id) {
    const newSelected = Object.assign({}, this.state.selected)
    newSelected[id] = !this.state.selected[id]
    this.setState({
      selected: newSelected,
      selectAll: 2
    })
  }

  toggleSelectAll() {
    let newSelected = {}

    if (this.state.selectAll === 0) {
      this.state.data.forEach(x => {
        newSelected[x.id] = true
      })
    }
    // console.log(JSON.stringify(newSelected));

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    })
  }

  fetchData = (state, instance) => {
    // console.log(instance);

    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true })
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered,
      this.state.dto
    )
      .then(res => {
        // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
        // console.log(res.data.result.length );
        // console.log(state.pageSize );
        if (res.data.result) {
          var pageSize =
            res.data.result.length > state.pageSize
              ? state.pageSize
              : res.data.result.length
          // console.log(pageSize );
          this.setState({
            data: res.data.result,
            pages: Math.ceil(res.data.totalRecord / state.pageSize),
            loading: false,
            modal: false,
            searchModal: false,
            pageSize: pageSize
          })
        }
      })
      .catch(() => {
        this.table.fireFetchData()
      })
  }

  render() {
    const ValidationSchema = Yup.object().shape({
      // name: Yup.string().trim().required('نام پیام'),
    })
    const { model, loading, data, pages, pageSize, dto } = this.state
    // console.log(loading);

    return (
      // !loading &&
      <div>
        <a
          onClick={this.handleModalShow}
          className="btn btn-primary react-table-add-btn"
          style={{ alignSelf: 'flex-start' }}>
          <i className="mdi mdi-magnify" />&nbsp;جستجو
        </a>
        <br />
        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            manual
            data={data}
            pages={pages}
            loading={loading}
            onFetchData={this.fetchData}
            ref={instance => {
              this.table = instance
            }}
            sorted={this.state.sorted}
            onSortedChange={(newSort, column) => {
              this.setState({ sorted: newSort })
            }}
            onPageSizeChange={pageSize => {
              // const { dispatch } = this.props;
              // dispatch( setPageSize(pageSize) )
              localStorage.setItem('pageSize', pageSize)
              // this.setState({ page: 0 });
            }}
            page={this.state.page}
            onPageChange={page => this.setState({ page })}
            defaultPageSize={pageSize}
            previousText="صفحه قبل"
            nextText="صفحه بعد"
            loadingText="در حال بارگذاری ..."
            noDataText="نتیجه ای یافت نشد"
            pageText="صفحه"
            ofText="از"
            rowsText="تعداد نمایش"
            getTableProps={() => ({ style: { display: 'block' } })}
            getTrProps={(state, rowInfo, column, instance) => {
              const newSelected = Object.assign({}, this.state.selected)
              const selected = rowInfo
                ? newSelected[rowInfo.original.id]
                : false
              return {
                style: {
                  backgroundColor: selected && '#5079F7',
                  color: selected && 'white'
                }
              }
            }}
            // defaultFilterMethod={(filter, row) =>
            //   String(row[filter.id]) === filter.value}
            columns={[
              {
                Header: 'ردیف',
                id: 'row',
                maxWidth: 50,
                filterable: false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                Cell: row => {
                  return row.index + 1
                }
              },
              {
                Header: 'نام و نام خانوادگی',
                id: 'fullName',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                accessor: el => el.firstName + el.lastName,
                filterMethod: (filter, row) => {
                  const escapedStr = filter.value.toLowerCase()
                  const termsArr = escapedStr.split(' ')
                  const finalRegexStr = termsArr.reduce(
                    (acc, curr, idx) => acc + '(?=.*' + curr + ')',
                    ''
                  )
                  const regex = new RegExp(finalRegexStr)
                  return regex.test(row[filter.id])
                },
                Cell: props => (
                  <span>
                    {props.original.firstName} {props.original.lastName}
                  </span>
                ),
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                )
              },
              {
                Header: 'شماره موبایل',
                accessor: 'mobile',
                id: 'mobile',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['mobile'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                )
              },
              {
                Header: 'ایمیل',
                accessor: 'email',
                id: 'email',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['name'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: props => <span>{props.original.email}</span>
              },
              {
                Header: 'متن پیام',
                accessor: 'message',
                id: 'message',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['name'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: props => <span>{props.original.message}</span>
              },
              {
                Header: 'تاریخ ارسال',
                accessor: 'createDateTime',
                id: 'createDateTime',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['createDateTime'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: props => (
                  <span>
                    {formatDefaultValue(props.original.createDateTime)}
                  </span>
                )
              },
              {
                Header: 'وضعیت',
                accessor: 'messageStatus',
                id: 'messageStatus',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                Cell: props => (
                  <span>
                    {
                      messageStatuses.filter(
                        el => el.id === props.original.messageStatus
                      )[0].name
                    }
                  </span>
                )
              },
              // {
              //     Header: "هزینه",
              //     accessor: "amount",
              //     id: "amount",
              //     style: { display: 'flex', alignItems: 'center', 'justifyContent': 'center' },
              //     filterMethod: (filter, rows) =>
              //         matchSorter(rows, filter.value, { keys: ["amount"] }),
              //     filterAll: true,
              //     Filter: ({ onChange }) =>
              //         <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
              //     Cell: props => (
              //         <NumberFormat thousandSeparator={true}
              //             className="numberFa"
              //             value={props.original.amount}
              //             displayType="text"
              //             suffix="ریال"
              //         />
              //     )
              // },
              {
                Header: 'ویرایش',
                accessor: 'id',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                sortable: false,
                filterable: false,
                //                     Filter: ({ filter, onChange }) =>
                //                         <a onClick={this.handleModalCreate} className="btn btn-primary react-table-add-btn"
                //                         ><i className="mdi mdi-plus"></i>
                //                             افزودن پیام جدید
                // </a>,
                Cell: row => (
                  <div>
                    {/* <a onClick={this.handleModalEdit} data-index={row.index} className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn" rel="tooltip" data-original-title="ویرایش"><i data-index={row.index} className="mdi mdi-pencil"></i></a> */}
                    {/* <Link to={'/admin/message/' + row.original.id + '/edit'} params={{ id: row.original.id }} className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn" rel="tooltip" data-original-title="ویرایش"><i className="mdi mdi-pencil"></i></Link> */}
                    <a
                      onClick={this.handleDelete}
                      data-index={row.index}
                      className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn"
                      data-original-title="حذف"
                      rel="tooltip">
                      <i data-index={row.index} className="mdi mdi-delete" />
                    </a>
                  </div>
                )
              }
              // {
              //   id: "checkbox",
              //   accessor: "",
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   className: 'selectAllCheckBoxHeader',
              //   Cell: ({ original }) => {
              //     return (
              //       <label className="input react-table-checkbox">
              //         <input
              //           className="input__field"
              //           type="checkbox"
              //           checked={this.state.selected[original.id] === true}
              //           onChange={() => this.toggleRow(original.id)}
              //         />
              //         <span className="input__text"></span>
              //       </label>
              //     );
              //   },
              //   // Filter: () =>
              //   //   <label className="input react-table-checkbox">
              //   //     <input
              //   //       className="input__field"
              //   //       type="checkbox"
              //   //       checked={this.state.selectAll === 1}
              //   //       ref={input => {
              //   //         if (input) {
              //   //           input.indeterminate = this.state.selectAll === 2;
              //   //         }
              //   //       }}
              //   //       onChange={() => this.toggleSelectAll()}
              //   //     />
              //   //     <span className="input__text"></span>
              //   //   </label>,
              //   Header: () =>
              //     <label className="input react-table-checkbox">
              //       <input
              //         className="input__field"
              //         type="checkbox"
              //         checked={this.state.selectAll === 1}
              //         ref={input => {
              //           if (input) {
              //             input.indeterminate = this.state.selectAll === 2;
              //           }
              //         }}
              //         onChange={() => this.toggleSelectAll()}
              //       />
              //       <span className="input__text"></span>
              //     </label>
              //   // <a onClick={this.handleDeleteSelected}
              //   //   className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn"
              //   //   disabled={Object.keys(this.state.selected).length === 0}>
              //   //   <i className="mdi mdi-delete"></i>
              //   // </a>
              //   ,
              //   sortable: false,
              //   maxWidth: 100,
              // },
            ]}
            // key={this.state.pageSize}
            // defaultPageSize={this.state.pageSize}
            className="-striped -highlight"
          />
        </div>
        <Modal
          open={this.state.searchModal}
          onClose={this.handleSearchModalHide}
          center
          classNames={{
            overlay: 'customOverlay',
            modal: 'customModal lg',
            closeButton: 'customModalCloseButton'
          }}>
          <Formik
            initialValues={dto}
            onSubmit={(values, { setSubmitting }) => {
              // console.log(values);
              this.handleSearch(values)
              setSubmitting(false)
            }}
            validationSchema={ValidationSchema}>
            {props => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                setFieldValue,
                handleSubmit
              } = props
              return (
                <div className="row" style={{ position: 'relative' }}>
                  <div className="col-md-12">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="form-inline">
                          <div className="col-md-2">
                            <label>نام</label>
                          </div>
                          <div className="col-md-4 ">
                            <Field
                              component={Input}
                              allowClear
                              onChange={e => {
                                setFieldValue('firstName', e.target.value)
                              }}
                              value={values.firstName}
                              name="firstName"
                            />
                            {getIn(errors, 'firstName') &&
                            getIn(touched, 'firstName') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.firstName}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="col-md-2">
                            <label>نام خانوادگی</label>
                          </div>
                          <div className="col-md-4">
                            <Field
                              component={Input}
                              allowClear
                              onChange={e => {
                                setFieldValue('lastName', e.target.value)
                              }}
                              value={values.lastName}
                              name="lastName"
                            />
                            {getIn(errors, 'lastName') &&
                            getIn(touched, 'lastName') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.lastName}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2">
                            <label>ایمیل</label>
                          </div>
                          <div className="col-md-4 ">
                            <Field
                              component={Input}
                              allowClear
                              onChange={e => {
                                setFieldValue('email', e.target.value)
                              }}
                              value={values.email}
                              name="email"
                            />
                            {getIn(errors, 'email') &&
                            getIn(touched, 'email') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.email}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="col-md-2">
                            <label>موبایل</label>
                          </div>
                          <div className="col-md-4">
                            <Field
                              component={Input}
                              allowClear
                              onChange={e => {
                                setFieldValue('mobile', e.target.value)
                              }}
                              value={values.mobile}
                              name="mobile"
                            />
                            {getIn(errors, 'mobile') &&
                            getIn(touched, 'mobile') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.mobile}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2">
                            <label>متن پیام</label>
                          </div>
                          <div className="col-md-10">
                            <Field
                              name="comment"
                              rows="10"
                              render={({ field }) => (
                                <textarea
                                  {...field}
                                  value={values.comment}
                                  className={
                                    getIn(errors, 'comment') &&
                                    getIn(touched, 'comment')
                                      ? 'textarea has-error rtl'
                                      : 'textarea required rtl'
                                  }
                                />
                              )}
                            />

                            {getIn(errors, 'comment') &&
                            getIn(touched, 'comment') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.comment}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="col-md-12">
                            <button
                              type="submit"
                              className={'icon button submit-btn pull-left'}
                              disabled={isSubmitting}>
                              {loading && (
                                <i className="mdi mdi-spin mdi-loading" />
                              )}
                              &nbsp; جستجو &nbsp;
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              )
            }}
          </Formik>
        </Modal>

        <Modal
          open={this.state.modal}
          onClose={this.handleModalHide}
          center
          classNames={{
            overlay: 'customOverlay',
            modal: 'customModal lg',
            closeButton: 'customModalCloseButton'
          }}>
          <Formik
            initialValues={model}
            onSubmit={(values, { setSubmitting }) => {
              // console.log(values);
              this.handleSubmit(values)
              setSubmitting(false)
            }}
            validationSchema={ValidationSchema}>
            {props => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                setFieldValue,
                handleSubmit
              } = props
              return (
                <div className="row" style={{ position: 'relative' }}>
                  <div className="col-md-12">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="form-inline">
                          {/* <div className="col-md-2">
                                                        <label>تقویم کلاس</label>
                                                    </div>
                                                    <div className="col-md-10 rtl">
                                                        <ClassSelect
                                                            required
                                                            defaultValue={values.classId}
                                                            onChange={(val) => {
                                                                setFieldValue('classId', val);
                                                            }}
                                                        />
                                                        <ErrorMessage component={ErrorPopUp} name="classId" />
                                                    </div>

                                                    <div className="clearfix"></div> */}

                          <div className="col-md-2">
                            <label>اتحادیه</label>
                          </div>
                          <div className="col-md-10 rtl">
                            <UnionSelectForAdmin
                              required
                              defaultValue={values.unionId}
                              onChange={val => {
                                setFieldValue('unionId', val)
                              }}
                            />
                            <ErrorMessage
                              component={ErrorPopUp}
                              name="unionId"
                            />
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2">
                            <label>تصویر</label>
                          </div>
                          <div className="col-md-4">
                            <PicUploaderLiner
                              label="انتخاب تصویر"
                              defaultValue={values.imagePath}
                              onChange={val => {
                                // console.log(val);
                                setFieldValue('imagePath', val)
                              }}
                            />
                            {getIn(errors, 'imagePath') &&
                            getIn(touched, 'imagePath') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.imagePath}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="col-md-2">
                            <label>جنسیت</label>
                          </div>
                          <div className="col-md-4">
                            <fieldset
                              key={0}
                              className="radio-button-list pull-right">
                              <label className="radio-inline">
                                <input
                                  className="input__field"
                                  type="radio"
                                  checked={parseInt(values.gender) === 0}
                                  onChange={val => {
                                    setFieldValue('gender', val.target.value)
                                  }}
                                  value={0}
                                />
                                <span className="input__text">مرد</span>
                              </label>
                            </fieldset>
                            <fieldset
                              key={1}
                              className="radio-button-list pull-right">
                              <label className="radio-inline">
                                <input
                                  className="input__field"
                                  type="radio"
                                  checked={parseInt(values.gender) === 1}
                                  onChange={val => {
                                    setFieldValue('gender', val.target.value)
                                  }}
                                  value={1}
                                />
                                <span className="input__text">زن</span>
                              </label>
                            </fieldset>
                            {getIn(errors, 'gender') &&
                            getIn(touched, 'gender') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.gender}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2">
                            <label>نام</label>
                          </div>
                          <div className="col-md-4">
                            <Field
                              type="text"
                              value={values.firstName}
                              onBlur={handleBlur}
                              name="firstName"
                              touched={touched.firstName}
                              className={
                                getIn(errors, 'firstName') &&
                                getIn(touched, 'firstName')
                                  ? 'text-input has-error rtl'
                                  : 'text-input required rtl'
                              }
                            />
                            {getIn(errors, 'firstName') &&
                            getIn(touched, 'firstName') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.firstName}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="col-md-2">
                            <label>نام خانوادگی</label>
                          </div>
                          <div className="col-md-4">
                            <Field
                              type="text"
                              value={values.lastName}
                              onBlur={handleBlur}
                              name="lastName"
                              touched={touched.lastName}
                              className={
                                getIn(errors, 'lastName') &&
                                getIn(touched, 'lastName')
                                  ? 'text-input has-error rtl'
                                  : 'text-input required rtl'
                              }
                            />
                            {getIn(errors, 'lastName') &&
                            getIn(touched, 'lastName') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.lastName}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2">
                            <label>کد ملی</label>
                          </div>
                          <div className="col-md-4">
                            <NumberFormat
                              format="##########"
                              isNumericString
                              allowNegative={false}
                              name="nationalCode"
                              onChange={e => {
                                setFieldValue('nationalCode', e.target.value)
                              }}
                              onBlur={handleBlur}
                              value={values.nationalCode}
                              className={
                                errors.nationalCode && touched.nationalCode
                                  ? 'text-input numberFa has-error'
                                  : 'text-input numberFa required'
                              }
                            />

                            {getIn(errors, 'nationalCode') &&
                            getIn(touched, 'nationalCode') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.nationalCode}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="col-md-2">
                            <label>شماره شناسنامه</label>
                          </div>
                          <div className="col-md-4">
                            <NumberFormat
                              isNumericString
                              allowNegative={false}
                              name="idNumber"
                              onChange={e => {
                                setFieldValue('idNumber', e.target.value)
                              }}
                              onBlur={handleBlur}
                              value={values.idNumber}
                              className={
                                errors.idNumber && touched.idNumber
                                  ? 'text-input numberFa has-error'
                                  : 'text-input numberFa required'
                              }
                            />

                            {getIn(errors, 'idNumber') &&
                            getIn(touched, 'idNumber') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.idNumber}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2">
                            <label>نام پدر</label>
                          </div>
                          <div className="col-md-4">
                            <Field
                              type="text"
                              value={values.fatherName}
                              onBlur={handleBlur}
                              name="fatherName"
                              touched={touched.fatherName}
                              className={
                                getIn(errors, 'fatherName') &&
                                getIn(touched, 'fatherName')
                                  ? 'text-input has-error rtl'
                                  : 'text-input required rtl'
                              }
                            />
                            {getIn(errors, 'fatherName') &&
                            getIn(touched, 'fatherName') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.fatherName}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="col-md-2">
                            <label>تاریخ تولد</label>
                          </div>
                          <div className="col-md-4">
                            <DatePicker
                              name="expireDate"
                              maxDate={moment()}
                              defaultValue={values.birthDate}
                              required
                              className="rtl"
                              onChange={val => {
                                setFieldValue('birthDate', val)
                              }}
                            />
                            <ErrorMessage
                              component={ErrorPopUp}
                              name="birthDate"
                            />
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2">
                            <label>کد رهگیری</label>
                          </div>
                          <div className="col-md-4">
                            <Field
                              type="text"
                              value={values.isicCode}
                              onBlur={handleBlur}
                              name="isicCode"
                              touched={touched.isicCode}
                              className={
                                getIn(errors, 'isicCode') &&
                                getIn(touched, 'isicCode')
                                  ? 'text-input has-error rtl'
                                  : 'text-input required rtl'
                              }
                            />
                            <ErrorMessage
                              component={ErrorPopUp}
                              name="isicCode"
                            />
                          </div>

                          <div className="col-md-2">
                            <label>شماره موبایل</label>
                          </div>
                          <div className="col-md-4">
                            <NumberFormat
                              isNumericString
                              allowNegative={false}
                              format="###########"
                              defaultValue={values.mobile}
                              name="mobile"
                              onChange={e => {
                                setFieldValue('mobile', e.target.value)
                              }}
                              onBlur={handleBlur}
                              className={
                                getIn(errors, 'mobile') &&
                                getIn(touched, 'mobile')
                                  ? 'text-input numberFa has-error rtl'
                                  : 'text-input numberFa required rtl'
                              }
                            />
                            {getIn(errors, 'mobile') &&
                            getIn(touched, 'mobile') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.mobile}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2">
                            <label>وضعیت</label>
                          </div>
                          <div className="col-md-4 rtl">
                            <StatusSelect
                              required
                              defaultValue={values.messageStatus}
                              onChange={val => {
                                setFieldValue('messageStatus', val)
                              }}
                              style={{
                                height: 40,
                                background: '#fff',
                                border: 'thin solid #b4b4b4',
                                borderRadius: 7
                              }}
                            />
                            <ErrorMessage
                              component={ErrorPopUp}
                              name="unionId"
                            />
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-12">
                            <br />
                            <input type="hidden" name="id" value={values.id} />
                            <button
                              type="submit"
                              className={'icon button submit-btn pull-left'}
                              disabled={isSubmitting}>
                              {loading && (
                                <i className="mdi mdi-spin mdi-loading" />
                              )}
                              &nbsp; ذخیره &nbsp;
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              )
            }}
          </Formik>
        </Modal>

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={
            'آیا از حذف  [' +
            this.state.model.firstName +
            ' ' +
            this.state.model.lastName +
            '] مطمئن هستید؟'
          }
        />
        {this.state.loading ? <Loading /> : ''}
      </div>
    )
  }
}

export default message
